import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CircularProgress as MuiCircularProgress } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { axios, endpoints } from 'Api';
import './ShortLink.module.css';

const CircularProgress = withStyles({
    circle: {
        color: '#fff !important'
    }
})(MuiCircularProgress);

const ShortLink = () => {
    const { key } = useParams();
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchLink = async () => {
            if (!key) {
                setError('Invalid link');
                return;
            }

            try {
                const response = await axios.post(endpoints.getLink, {
                    key,
                });

                if (response?.data?.success && response?.data?.data?.url) {
                    window.location.href = response.data.data.url;
                } else {
                    setError(response?.data?.message || 'Failed to get redirect link');
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error fetching link:', err);
                setError(err?.response?.data?.message || 'Failed to get redirect link');
            }
        };

        fetchLink();
    }, [key]);

    return (
        <div className="short-link-container">
            {/* Blank page - functionality to be added later */}
            {error ? (
                <div className="short-link-error">{error}</div>
            ) : (
                <CircularProgress />
            )}
        </div>
    );
};

export default ShortLink;
